/**
 * @generated SignedSource<<75876f516b2c1f5c888630c5f20f8890>>
 * @relayHash 73081cf58a8e81ccffae89b1d6d74f86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d812e16d34970e7df70d4950bf70cc3a1a6c5ad17a44585d19928c7e2a1b68d

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubEditMode"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "operationType"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    v5 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v6 = {
      "kind": "Variable",
      "name": "operationType",
      "variableName": "operationType"
    },
    v7 = [{
      "kind": "ScalarField",
      "name": "asapIssuer"
    }, {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    }, {
      "kind": "ScalarField",
      "name": "mediaToken"
    }, {
      "kind": "ScalarField",
      "name": "mediaUrl"
    }];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      "kind": "Fragment",
      "name": "hubBootstrapWrapperQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
        }]
      }, {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v2 /*: any*/, v1 /*: any*/, v4 /*: any*/, v3 /*: any*/],
      "kind": "Operation",
      "name": "hubBootstrapWrapperQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": [{
            "kind": "Variable",
            "name": "ari",
            "variableName": "hubAri"
          }, v6 /*: any*/],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v7 /*: any*/
        }, {
          "alias": "pageMediaConfig",
          "args": [{
            "kind": "Variable",
            "name": "ari",
            "variableName": "pageAri"
          }, v6 /*: any*/],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v7 /*: any*/
        }, {
          "args": [{
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
          }],
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "type"
            }, {
              "concreteType": "HelpCenterBranding",
              "kind": "LinkedField",
              "name": "helpCenterBranding",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "fileId"
                }, {
                  "kind": "ScalarField",
                  "name": "url"
                }]
              }, {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "primary"
                }]
              }]
            }],
            "type": "HelpCenter"
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [{
          "args": [{
            "items": [{
              "kind": "Variable",
              "name": "cloudIds.0",
              "variableName": "cloudId"
            }],
            "kind": "ListValue",
            "name": "cloudIds"
          }],
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "cloudUrl"
          }]
        }]
      }]
    },
    "params": {
      "id": "0d812e16d34970e7df70d4950bf70cc3a1a6c5ad17a44585d19928c7e2a1b68d",
      "metadata": {},
      "name": "hubBootstrapWrapperQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "fc48fc6598d48c617cc16e7581ac6b2b";
export default node;